<template>
  <div>
    <!-- 尚未錄音 -->
    <div
      class="pointer position-relative rounded-circle p-2 border_main4"
      :class="{ 'd-none': showStage !== 0, 'd-inline-block': showStage === 0 }"
    >
      <div>
        <img
          src="@/assets/image/gept/micro01_off.png"
          alt=""
          class="img-fluid object-contain"
        >
      </div>
    </div>

    <!-- 錄音中 -->
    <div
      class="pointer position-relative rounded-circle p-2 border_main4"
      :class="{ 'd-none': showStage !== 1, 'd-inline-block': showStage === 1 }"
    >
      <div class="p-2 mb-1 d-flex justify-content-center">
        <div class="border border_main4 rounded-circle p-2 pointer">
          <div class="record_img">
            <canvas
              id="canvas"
              ref="recordRef"
              class="canvas canvas_Recognition"
            ></canvas>
          </div>
        </div>
      </div>

      <div
        class="voice_stop position-absolute"
        @click.prevent="stopRecord()"
        :class="{ 'opacity-50': !canStop }"
      >
        <img
          src="@/assets/image/gept/voice_stop.png"
          alt=""
          class="img-fluid object-contain"
        >
      </div>
    </div>

    <!-- 錄音結束 -->
    <div class="pointer rounded-circle p-2 border_main4">
      <img
        src="@/assets/image/gept/micro01_finish.png"
        alt=""
        class="img-fluid object-contain"
        :class="{ 'd-none': showStage !== 2, 'd-inline-block': showStage === 2 }"
      >
    </div>
  </div>
</template>


<script>
import api from '@/store/api'
import Recorder from 'js-audio-recorder'
import { mapGetters } from 'vuex'
export default {
  name: "Recognition",
  props: {
    showStage: {
      type: Number,
      default: 0
    }
  },
  watch: {
    showStage: {
      immediate: true,
      handler (newVal, oldVal) {
        if (newVal !== oldVal && newVal === 1) {
          // this.initMediaDevices()
          this.safeInitMediaDevices()
        } else if (oldVal === 1 && newVal === 2) {
          this.stopRecord()
        }
      }
    }
  },
  data () {
    return {
      recorderJS: null,
      drawRecordId: null,
      canStop: false,
      isRecording: false
    }
  },
  computed: {
    ...mapGetters(['remainPoints'])
  },
  beforeDestroy () {
    if (this.recorderJS) {
      this.recorderJS.destroy().then(() => {
        this.recorderJS = null
      })
    }
    cancelAnimationFrame(this.drawRecordId)
  },
  methods: {
    handleMicError (err) {
      const name = err?.name
      if (name === 'NotAllowedError') {
        this.showMicError(this.$t('GEPT.mic.notAllowed'))
      } else if (name === 'NotFoundError') {
        this.showMicError(this.$t('GEPT.mic.notFound'))
      } else if (name === 'NotReadableError') {
        this.showMicError(this.$t('GEPT.mic.notReadable'))
      } else if (name === 'SecurityError') {
        this.showMicError(this.$t('GEPT.mic.security'))
      } else {
        this.showMicError(this.$t('GEPT.mic.default'))
        console.error('[錄音錯誤]', err)
      }
    },
    errorMessage (text) {
      this.$swal({
        title: this.$t('GEPT.common.notice'),
        text,
        icon: "warning",
        customClass: {
          confirmButton: 'btn-submit gept_main_bg'
        }
      })
    },
    async safeInitMediaDevices () {
      try {
        const stream = await navigator.mediaDevices.getUserMedia({ audio: true })

        if (window.AudioContext) {
          try {
            const ctx = new AudioContext()
            if (ctx.state === 'suspended') await ctx.resume()
            ctx.close() // 關掉測試用的 context
          } catch (e) {
            console.warn('[AudioContext resume 失敗]', e)
          }
        }

        this.startRecord()
      } catch (err) {
        this.handleMicError(err)
      }
    },
    initMediaDevices () {
      console.log('initMediaDevices')
      if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
        this.errorMessage(this.$t('GEPT.mic.unsupported'))
        return
      }

      navigator.mediaDevices.getUserMedia({ audio: true })
        .then(() => {
          this.startRecord()
        })
        .catch((err) => {
          console.error('麥克風啟動錯誤：', err)
          if (err.name === 'NotAllowedError') {
            this.errorMessage(this.$t('GEPT.mic.permissionDenied'))
          } else if (err.name === 'NotFoundError') {
            this.errorMessage(this.$t('GEPT.mic.noDevice'))
          } else if (err.name === 'NotReadableError') {
            this.errorMessage(this.$t('GEPT.mic.notReadable'))
          } else {
            this.errorMessage(this.$t('GEPT.mic.default'))
          }
        })
    },

    startRecord () {
        try {
          this.recorderJS = new Recorder()
        } catch (err) {
          console.error('[Recorder 初始化失敗]', err)
          this.showMicError(this.$t('GEPT.mic.initFailed'))
          return
        }

        this.recorderJS.start()
          .then(() => {
            this.isRecording = true
            this.drawRecord()
          })
          .catch((err) => {
            console.error('[錄音啟動失敗]', err)
            this.showMicError(this.$t('GEPT.mic.startFailed'))
            this.recorderJS?.stop()
            this.recorderJS?.destroy()
            this.recorderJS = null
            cancelAnimationFrame(this.drawRecordId)
            this.drawRecordId = null
          })

        this.recorderJS.onprogress = (params) => {
          if (params.duration > 3) {
            this.canStop = true
          }
          // if (!this.isCanActive) {
          //   this.stopRecord()
          // }
        }
      // if (this.recorderJS) {
      //   // 防止重複建立
      //   console.warn('已有 recorder 實例')
      //   return
      // }

      // this.recorderJS = new Recorder()

      // this.recorderJS.start()
      //   .then(() => {
      //     this.drawRecord()
      //     this.isRecording = true
      //   })
      //   .catch((err) => {
      //     console.error('[錄音啟動失敗]', err ?? '未知錯誤')
      //     this.errorMessage('無法啟動錄音，請確認麥克風權限或設備正常。')
      //     this.stopRecord()
      //   })

      // this.recorderJS.onprogress = ({ duration }) => {
      //   if (duration > 3) {
      //     this.canStop = true
      //   }
      // }
    },

    stopRecord () {
      if (this.recorderJS && this.isRecording) {
        this.recorderJS.stop()
        const audioBlob = this.recorderJS.getWAVBlob()
        this.$emit('emitAudioData', audioBlob)

        this.canStop = false
        this.isRecording = false

        cancelAnimationFrame(this.drawRecordId)

        this.recorderJS.destroy().then(() => {
          this.recorderJS = null
        })
      }
    },

    getSTT (audioData) {
      let path = `/ERS?stext=${this.sText}`

      api.request({
        method: 'post',
        maxBodyLength: Infinity,
        url: path,
        headers: {
          'Content-Type': 'audio/wave'
        },
        data: audioData
      })
      .then((response) => {
        this.$emit('emitERS', response.data)
      })
      .catch((error) => {
        console.error('STT 上傳失敗', error)
      })
    },

    drawRecord () {
      this.drawRecordId = requestAnimationFrame(this.drawRecord)
      this.drawWave({
        canvas: this.$refs.recordRef,
        dataArray: this.recorderJS.getRecordAnalyseData(),
        bgcolor: 'rgb(200, 200, 200, 0)',
        lineWidth: 2,
        lineColor: 'rgb(255, 255, 255)'
      })
    },

    drawWave({
      canvas,
      dataArray,
      bgcolor = 'rgb(200, 200, 200)',
      lineWidth = 2,
      lineColor = 'rgb(0, 0, 0)'
    }) {
      if (!canvas) return
      canvas.width = 240
      canvas.height = 240

      let background = new Image()
      background.src = require('@/assets/image/gept/recording_img.png')
      background.size = 'contain'

      const ctx = canvas.getContext('2d')
      const bufferLength = dataArray.length
      const sliceWidth = canvas.width / bufferLength
      let x = 0
      ctx.drawImage(background, 0, 0)
      ctx.fillStyle = bgcolor
      ctx.fillRect(0, 0, canvas.width, canvas.height)

      ctx.lineWidth = lineWidth
      ctx.strokeStyle = lineColor

      ctx.beginPath()

      for (let i = 0; i < bufferLength; i++) {
        const v = dataArray[i] / 128
        const y = (v * canvas.height) / 2

        if (i === 0) {
          ctx.moveTo(x, y)
        } else {
          ctx.lineTo(x, y)
        }
        x += sliceWidth
      }

      ctx.lineTo(canvas.width, canvas.height / 2)
      ctx.stroke()
    },

    stopAction () {
      this.$emit('stopAction')
    }
  }
}
</script>

<style lang="scss" scoped>
  .canvas {
    background-image: url('~@/assets/image/gept/recording_img.png');
    background-repeat: no-repeat;
    background-size: contain;
  }
  .voice_stop {
    right: 5%;
    bottom: -5%;
    z-index: 2;
  }
  .record_img {
    width: 240px;
    height: 240px;
    background-image: url('~@/assets/image/gept/recording_img2.png');
    background-size: 240px;
    background-size: cover;
  }
  .canvas_Recognition {
    width: 100%;
    height: 100%;
    max-width: 240px;
    max-height: 240px;
  }
</style>
